import { Tab, TabList, TabPanel, TabPanels, Tabs, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { Location, useLocation, useNavigate } from 'react-router-dom';
import { LoginForm } from './components/LoginForm';
import { Logo } from '../../components/atoms/Logo';
import { RegisterForm } from './components/RegisterForm';
import { MainTemplate } from '../../templates/MainTemplate';
import { useTheme } from '../../contexts/ThemeProvider';
import { LoginExCliente } from './components/LoginExCliente';
import { isAuthenticated } from '../../service/axios';

const LoginMethod = () => {
  const [exClient, setExClient] = useState(false);

  if (exClient) {
    return <LoginExCliente setExClient={setExClient} />;
  }

  return <LoginForm setExClient={setExClient} />;
};

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(0);
  const { integratedLogin, cpfModule } = useTheme();

  const showRegistrationTabs = !integratedLogin || cpfModule;

  const from = (location.state as { from?: Location } | null)?.from;

  if (isAuthenticated()) navigate(from ? `${from.pathname}${from.search}` : '/');

  return (
    <MainTemplate hideTopMenu>
      <VStack width={{ base: '85%', lg: '500px' }} margin={'auto'} paddingTop={'50px'}>
        <Logo height={'90px'} objectFit={'contain'} w={'auto'} />

        {showRegistrationTabs ? (
          <Tabs
            index={tabIndex}
            onChange={setTabIndex}
            isFitted
            width={'100%'}
            padding={0}
            paddingTop={'30px'}
            variant="soft-rounded"
            colorScheme="blackAlpha900"
          >
            <TabList
              backgroundColor="white"
              width={'100%'}
              margin="auto"
              padding="5px"
              border={'1px solid #ffffff'}
              borderRadius={'40px'}
            >
              <Tab padding={'5px'} _selected={{ color: 'white', backgroundColor: '#252F2C' }}>
                Login
              </Tab>
              <Tab padding={'5px'} _selected={{ color: 'white', backgroundColor: '#252F2C' }}>
                Registro
              </Tab>
            </TabList>
            <TabPanels paddingTop={'20px'}>
              <TabPanel padding={0}>
                <LoginMethod />
              </TabPanel>

              <TabPanel padding={0}>
                <RegisterForm onSwitchToLogin={() => setTabIndex(0)} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        ) : (
          <VStack w={'100%'} paddingTop={'30px'}>
            <LoginMethod />
          </VStack>
        )}
      </VStack>
    </MainTemplate>
  );
}
